import clsx from "clsx";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ApiClient } from "@/api/client";
import Breadcrumbs from "~/components/common/breadcrumbs";
import Icon from "~/components/common/icon";
import ClientComments from "~/components/pages/sectionNew/clientComments";
import FilterBlock from "~/components/pages/sectionNew/filterBlock";
import StubPage from "~/components/pages/stub";
import { showPopup } from "~/redux/action-creaters/popup";
import { popupTypes } from "~/redux/reducers/popupReducer";
import { setTextCity } from "~/utils";
import errorSent from "~/utils/errors/errorSent";
import { safeSessionStorage } from "~/utils/safeStorage";
import { ECOMMERCE_LISTS, useEcommerceImpressions } from "~/utils/tracking";

import Pagen from "../../../common/pagen";
import Banner from "../banner";
import Product from "../product";
import Sort from "../sort";
import styles from "./index.module.scss";

const ManagerScripts = dynamic(
  () => import("~/components/pages/sectionNew/managerScripts"),
  {
    ssr: false,
    loading: () => null,
  },
);

export default function SectionNewBody({ section = {} }: any) {
  const { products, count, params, meta, stubData } = useSelector(
    (state: any) => state.section,
  );
  const { deliveyCity } = useSelector((state: any) => state.location);
  const [isShowMobileFilter] = useState(false);
  const { user } = useSelector((state: any) => state.user);
  const [managerInstall, setManagerInstall] = useState<any>([]);
  const [managerData, setManagerData]: any = useState({});
  const [managerDataTk, setManagerDataTk]: any = useState({});
  const [managerComments, setManagerComments] = useState<any>([]);
  const { host } = useSelector((state: any) => state.params);
  const dispatch = useDispatch();

  useEffect(() => {
    const body: any = document.querySelector("body");
    if (!isShowMobileFilter) {
      body.classList.remove("popup");
    } else {
      body.classList.add("popup");
    }
  }, [isShowMobileFilter]);

  const router = useRouter();

  const isAdminUser =
    user?.IS_ADMIN || user?.IS_MANAGER || Boolean(router.query.isManager);

  useEffect(() => {
    if (isAdminUser) {
      const ids = products.map((item: any) => item.ID);
      const getComments = async () => {
        setManagerComments(await ApiClient.manager.getManagerComments(ids));
      };
      const getManagerInstall = async () => {
        setManagerInstall(await ApiClient.manager.getManagerInstall(ids));
      };
      const getData = async () => {
        setManagerData(
          (await ApiClient.manager.getManagerDelivery(
            ids,
            // @ts-ignore
            router.query.time,
            router.query.weekday,
          )) || {},
        );
      };
      const getDataTk = async () => {
        setManagerDataTk(
          (await ApiClient.manager.getManagerDeliveryTk(
            ids,
            // @ts-ignore
            router.query.time,
            router.query.weekday,
          )) || {},
        );
      };
      getComments();
      getData();
      getDataTk();
      // getManagerInstall();
    }
  }, [isAdminUser, products]);

  useEcommerceImpressions(products, ECOMMERCE_LISTS.catalog);

  const [viewType, setViewType] = useState(0);

  useEffect(() => {
    if (products.length === 0 && !stubData?.h1) {
      errorSent("errorHandled", "emptyCatalog", {
        source: safeSessionStorage.getItem("previosUrl") || document.referrer,
      });
    }
  }, [products]);

  const { domainData } = useSelector((state: any) => state.contacts);
  let titleCity = domainData.declension;
  if (titleCity?.includes("Москве")) {
    titleCity = "Москве и Московской области";
  } else if (titleCity?.includes("Санкт-")) {
    titleCity = "Санкт-Петербурге и Ленинградской области";
  }

  useEffect(() => {
    const calcId = router.query.calcProductId;
    if (calcId) {
      const productId = Number(calcId);
      const product = products.find((p: any) => Number(p.ID) === productId);
      if (product) {
        dispatch(
          showPopup(popupTypes.installCalculator, {
            product,
          }),
        );
      }
    }
  }, [router.query.calcProductId, products]);

  // @ts-ignore
  return (
    <div className="container">
      <Breadcrumbs />

      <h1 className={styles.h1}>
        <span>{setTextCity(host, domainData, meta.h1 ?? section.NAME)} </span>
        {host
          .replace("farkop-msk", "farkop")
          .replace("farkop-seo", "farkop") !== "farkop.ru" && (
          <span className={styles.h1City}>
            в {titleCity}
            {params.pageNum > 1 && ` - Страница ${params.pageNum}`}
          </span>
        )}
      </h1>
      {!stubData && <Banner cityName={deliveyCity} sectionId={section.ID} />}
      <div className={styles.Content}>
        {(!stubData || stubData.isShowFilter) && (
          <div className={styles.Top}>
            <FilterBlock section={section} productCount={products.length} />
          </div>
        )}
        {!stubData && (
          <div className={styles.Block}>
            {isAdminUser && <ManagerScripts />}
            <ClientComments />
            <div className={styles.Toolbar}>
              {isAdminUser && count > 1 && <Sort />}
              <div className={styles.View}>
                <div>
                  {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <span
                    className={clsx(viewType === 0 && styles.Selected)}
                    onClick={() => {
                      setViewType(0);
                    }}
                  >
                    <Icon id="list" size={13} fill="#000" />
                  </span>
                  {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <span
                    className={clsx(viewType === 1 && styles.Selected)}
                    onClick={() => {
                      setViewType(1);
                      // @ts-ignore
                      if (typeof ym !== "undefined") {
                        // @ts-ignore
                        ym(20518312, "reachGoal", "changeCatalogViewToTable");
                      }
                    }}
                  >
                    <Icon id="table" size={13} fill="#000" />
                  </span>
                </div>
              </div>
            </div>
            <div
              id="catalog"
              className={clsx(
                styles.Products,
                viewType === 1 && styles.ProductsTable,
              )}
            >
              {products.map((product: any) => (
                <Product
                  viewType={viewType}
                  data={product}
                  key={product.ID}
                  managerDelivery={managerData[product.ID]}
                  managerDeliveryTk={managerDataTk[product.ID]}
                  managerComment={managerComments[product.ID]}
                  managerInstall={managerInstall[product.ID]}
                />
              ))}
              {products.length === 0 && (
                <span className={styles.Empty}>
                  По заданным фильтрам нет товаров.
                </span>
              )}
            </div>
            <div className={styles.Bottom}>
              <Pagen
                count={count}
                size={params.pageSize}
                currentNum={params.pageNum}
              />
            </div>
            {meta.seoBottom && params.pageNum === 1 && (
              <div className="text">
                <div
                  className={styles.SeoBottom}
                  dangerouslySetInnerHTML={{
                    __html: setTextCity(host, domainData, meta.seoBottom),
                  }}
                />
              </div>
            )}
          </div>
        )}
        {stubData && <StubPage stub={stubData} />}
      </div>
    </div>
  );
}
